import { ApiError } from './api.error';

export class BadRequestError extends ApiError {
    constructor(clazz: string, message: string, error?: Error) {
        super(clazz, message, error);
        Object.setPrototypeOf(this, BadRequestError.prototype);
    }
}